import {
  ControlProps,
  components as ReactSelectComponents,
  GroupBase,
  SelectComponentsConfig,
} from 'react-select';
import type { ISelectCustomProps } from '../interfaces';

import styles from '../select.module.scss';

interface IProps<SOption, IsMulti extends boolean, Group extends GroupBase<SOption>> {
  dataTest: string,
  components?: SelectComponentsConfig<SOption, IsMulti, Group>,
  ownProps: ControlProps<SOption, IsMulti, Group> & {
    selectProps: ISelectCustomProps,
  },
}

const Control = <SOption, IsMulti extends boolean, Group extends GroupBase<SOption>>({
  dataTest,
  components = {},
  ownProps: {
    children,
    selectProps,
    ...otherProps
  },
}: IProps<SOption, IsMulti, Group>) => {
  const dataTestAttr = `${ dataTest }Content`;
  const content = selectProps?.textRight;

  const childrenArray = Array.isArray(children) ? children : [children];
  const [valueContainer, ...indicators] = childrenArray;

  const Wrapper = components?.Control ?? ReactSelectComponents.Control;

  return (
    <Wrapper { ...otherProps } selectProps={ selectProps }>
      { valueContainer }
      { content && <div className={ styles.controlContent } data-test={ dataTestAttr }>{ content }</div> }
      { indicators }
    </Wrapper>
  );
};

export default Control;
